import Vue from "vue";
import "./svg";
export default (() => {
    Vue.component("CustomRoomDetail", () => import("@/components/CustomRoomDetail"));
    Vue.component("CustomHeader", () => import("@/components/CustomHeader"));
    Vue.component("OrderItem", () => import("@/components/OrderItem"));
    Vue.component("HotelItem", () => import("@/components/HotelItem"));
    Vue.component("OrderItem", () => import("@/components/OrderItem"));
    Vue.component("LazyList", () => import("@/components/LazyList"));
    Vue.component("ToTop", () => import("@/components/ToTop"));
})();
